<template>
  <v-card v-if="hasAnyServiceAction">
    <v-toolbar flat>
      <v-toolbar-title>Service Modifications</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-card flat class="text-center">
      <div class="d-flex flex-wrap justify-center pa-4">
        <v-btn
          v-if="isServiceRestorationReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          @click="$emit('service-restoration')"
        >
          Service Restoration
        </v-btn>
        <v-btn
          v-if="isDisconnectReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!isOriginal"
          @click="$emit('disconnect')"
        >
          Cancel Service
        </v-btn>
        <v-btn
          v-if="isEditReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!isOriginal || orderBandwidth === ''"
          @click="$emit('edit')"
        >
          Edit
        </v-btn>
        <v-btn
          v-if="isCorrectionReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="isCorrectionDisabled"
          @click="$emit('correction')"
        >
          Correction
        </v-btn>
        <v-btn
          v-if="isResumeReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!isOriginal || !isOnHold"
          @click="$emit('resume')"
        >
          Resume Order
        </v-btn>
        <v-btn
          v-if="isReversalReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!canBeDispute"
          @click="$emit('reversal')"
        >
          Reversal
        </v-btn>
        <v-btn
          v-if="isCancelReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!isOriginal"
          @click="$emit('withdraw')"
        >
          Withdraw Order
        </v-btn>
        <v-btn
          v-if="isTransferLossRemoveReady"
          class="service-action-btn primary ma-2"
          elevation="4"
          :disabled="!isOriginal"
          @click="$emit('remove-configuration')"
        >
          Remove Configuration
        </v-btn>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import {
  isCorrectionActionAllowed,
  isCorrectionActionDisabled
} from "@/utils/nbn-order-correction";
import { canBeDispute as isWithinReversalWindow } from "@/utils/nbn-reversal";

export default {
  name: "NbnOrderPrimaryActions",
  data: () => ({
    currentDate: new Date(),
    disputeTimer: null
  }),
  mounted() {
    this.disputeTimer = setInterval(() => {
      this.currentDate = new Date();
    }, 60000);
  },
  beforeDestroy() {
    if (this.disputeTimer) {
      clearInterval(this.disputeTimer);
    }
  },
  computed: {
    isServiceRestorationReady() {
      return (
        this.featureFlags.sog5391 &&
        this.isOriginal &&
        this.nbnOrder.status != "Transferred Out" &&
        this.nbnOrder.status != "Cancelled" &&
        this.nbnOrder.status != "Disconnecting" &&
        this.nbnOrder.status != "Disconnected" &&
        this.nbnOrder.status != "Rejected"
      );
    },
    isDisconnectReady() {
      return this.nbnOrder.status != null && this.nbnOrder.status === "Complete";
    },
    isEditReady() {
      return (
        this.orderType != "nbn modify" &&
        this.nbnOrder.status != null &&
        (this.nbnOrder.status === "Complete" ||
          this.nbnOrder.status === "Held" ||
          this.nbnOrder.status === "Scheduled")
      );
    },
    isCorrectionReady() {
      const recordId =
        (this.nbnOrderRecord && this.nbnOrderRecord.id) || this.nbnOrder.id;
      return isCorrectionActionAllowed({
        isSuperAdmin: this.isSuperAdmin,
        isOriginal: this.isOriginal,
        recordId
      });
    },
    isCorrectionDisabled() {
      return isCorrectionActionDisabled(this.nbnOrder && this.nbnOrder.status);
    },
    isResumeReady() {
      return this.featureFlags.sog4117 && this.isOriginal;
    },
    isOnHold() {
      return (
        this.nbnOrder.onHold &&
        (this.nbnOrder.status == "Scheduled" || this.nbnOrder.status == "Held")
      );
    },
    isReversalReady() {
      return (
        this.featureFlags.sog5946 && this.nbnOrder.status == "Transferred Out"
      );
    },
    canBeDispute() {
      return isWithinReversalWindow(this.transferredDate, this.currentDate);
    },
    isCancelReady() {
      return (
        this.featureFlags.sog1569 &&
        this.isOriginal &&
        this.nbnOrder.status != null &&
        this.nbnOrder.status != "Complete" &&
        this.nbnOrder.status != "Cancelled" &&
        this.nbnOrder.status != "Disconnecting" &&
        this.nbnOrder.status != "Disconnected" &&
        this.nbnOrder.status != "Updating" &&
        this.nbnOrder.status != "Rejected" &&
        this.nbnOrder.status != "Transferred Out"
      );
    },
    isTransferLossRemoveReady() {
      return (
        this.featureFlags.sog1538 &&
        this.nbnOrder.status != null &&
        (this.nbnOrder.status == "Complete" ||
          this.nbnOrder.status == "Cancelled") &&
        this.isAdmin
      );
    },
    hasAnyServiceAction() {
      return (
        this.isServiceRestorationReady ||
        this.isDisconnectReady ||
        this.isEditReady ||
        this.isCorrectionReady ||
        this.isResumeReady ||
        this.isReversalReady ||
        this.isCancelReady ||
        this.isTransferLossRemoveReady
      );
    }
  }
};
</script>

<style scoped>
.service-action-btn {
  min-width: 160px;
  font-weight: bold;
}
</style>
